export enum CompetenciaFormatEnum {
  ANO = 'YYYY',
  MES_ANO = 'MM/YYYY'
}
